import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import type { ApiResponse } from '@/lib/api/client'
import type {
    ShopSiteSetting,
    ShopSiteSettingInput,
    ShopSiteSettingKind,
} from '@/lib/api/shop-site-settings-api'
import { shopSiteSettingsApi } from '@/lib/api/shop-site-settings-api'
import { m } from '@/lib/paraglide/messages'

export const shopSiteSettingsKeys = {
    all: ['shop-site-settings'] as const,
}

export function useShopSiteSettings() {
    return useQuery({
        queryKey: shopSiteSettingsKeys.all,
        queryFn: () => shopSiteSettingsApi.list(),
    })
}

// Lỗi kiểm dữ liệu do màn hiện cạnh ô; hook báo thành công và thay kind vừa
// lưu (version mới) vào cache để lần lưu sau gửi đúng version.
export function useSaveShopSiteSetting() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: ({
            kind,
            input,
        }: {
            kind: ShopSiteSettingKind
            input: ShopSiteSettingInput
        }) => shopSiteSettingsApi.save(kind, input),
        onSuccess: (res) => {
            toast.success(m.siteSettings_saved())
            const saved = res.data
            if (!saved) return
            qc.setQueryData<ApiResponse<{ settings: ShopSiteSetting[] }>>(
                shopSiteSettingsKeys.all,
                (old) =>
                    old?.data
                        ? {
                              ...old,
                              data: {
                                  settings: old.data.settings.map((s) =>
                                      s.kind === saved.kind ? saved : s,
                                  ),
                              },
                          }
                        : old,
            )
        },
    })
}
